import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";
import { callRejectionFacts, callRejectionV2Facts } from "../subjects/stopEvent/callRejectionFacts";

/**
 * The TMS refused the call because it arrived out of order.
 *
 * An arrival before the loaded call, or a call before the previous stop was departed.
 */
export const callOutOfSequenceV1 = tmsEventKind(
  { category: "callRejection", kind: "callOutOfSequence", version: 1 },
  { refs: stopEventRefs, facts: callRejectionFacts },
);

export const CallOutOfSequenceV1Schema = callOutOfSequenceV1.schema;
export const CallOutOfSequenceV1FactsSchema = callOutOfSequenceV1.facts;

export type CallOutOfSequenceV1 = z.infer<typeof CallOutOfSequenceV1Schema>;
export type CallOutOfSequenceV1Facts = z.infer<typeof CallOutOfSequenceV1FactsSchema>;

/**
 * Version 2: the same refusal, plus what the driver's call said — its type, load, trailers, consignee, and lines.
 */
export const callOutOfSequenceV2 = tmsEventKind(
  { category: "callRejection", kind: "callOutOfSequence", version: 2 },
  { refs: stopEventRefs, facts: callRejectionV2Facts },
);

export const CallOutOfSequenceV2Schema = callOutOfSequenceV2.schema;
export const CallOutOfSequenceV2FactsSchema = callOutOfSequenceV2.facts;

export type CallOutOfSequenceV2 = z.infer<typeof CallOutOfSequenceV2Schema>;
export type CallOutOfSequenceV2Facts = z.infer<typeof CallOutOfSequenceV2FactsSchema>;

/** Every version of `callOutOfSequence`, keyed by version. What `catalog.ts` places under `callRejection`. */
export const callOutOfSequence = { 1: callOutOfSequenceV1, 2: callOutOfSequenceV2 } as const;
